import React, { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { directUrl } from '../../../helpers/Constants';



function Home() {
    let navigate = useNavigate()
    useEffect(()=>{
        let user = localStorage.getItem('user')
         user = JSON.parse(user)
         if(user){
            console.log("user",user.role_id,user)
            if (user.role_id === 1) {
              navigate(`${directUrl}super-admin/auditor`)
            }
            if (user.role_id === 2) {
              navigate(`${directUrl}auditor/dashboard`)
            }
            if (user.role_id === 3) {
              navigate(`${directUrl}compliancer/login`)
            }
            if (user.role_id === 4) {
              navigate(`${directUrl}approver/reports-approver`)
            }
         }else{
            navigate(`${directUrl}sign-in`)
         }
        
       
      })
   
}

export default Home;